import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableSkeleton } from '@/shared/components/TableSkeleton';
import { formatDate } from '@/shared/lib/format';
import type { Subscriber } from '../api/subscribersApi';

type Props = { rows: Subscriber[]; isLoading: boolean; onRemove?: ((s: Subscriber) => void) | undefined; removingId?: string | null };
const COLUMNS = ['Name', 'Number', 'Email', 'Opt-in', ''];

export function SubscribersTable({ rows, isLoading, onRemove, removingId }: Props) {
  return (
    <TableContainer>
      <Table size="small" aria-label="Subscribers">
        <TableHead>
          <TableRow>{COLUMNS.map((c, i) => <TableCell key={c || `col-${i}`}>{c}</TableCell>)}</TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? <TableSkeleton columns={COLUMNS.length} rows={5} /> : rows.map((s) => (
            <TableRow key={s.id} hover>
              <TableCell>{s.name}</TableCell>
              <TableCell>{s.phoneMasked}</TableCell>
              <TableCell>{s.emailMasked ?? 'Not given'}</TableCell>
              <TableCell>
                {s.optedIn ? (
                  <Chip color="success" label={`Opted in${s.optedInAt ? ` ${formatDate(s.optedInAt)}` : ''}`} />
                ) : (
                  <Chip color="warning" label="No opt-in, will not receive" />
                )}
              </TableCell>
              <TableCell align="right">
                {onRemove ? (
                  <Button size="small" color="error" disabled={removingId === s.id} onClick={() => { onRemove(s); }} aria-label={`Remove ${s.name}`}>
                    Remove
                  </Button>
                ) : null}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
